import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

import { useStopCampaignSubscriber } from '../../hooks/useStopCampaignSubscriber';

interface StopSubscriberModalProps {
  campaignId: string;
  subscriberId: string;
  onClose: () => void;
  onSuccess?: () => void;
}

export const StopSubscriberModal = ({
  campaignId,
  subscriberId,
  onClose,
  onSuccess,
}: StopSubscriberModalProps) => {
  const { t } = useTranslation();
  const { stopSubscriberAsync, stopSubscriberStatus } = useStopCampaignSubscriber();
  const isStopping = stopSubscriberStatus === 'pending';

  const handleStop = async () => {
    try {
      await stopSubscriberAsync({ campaignId, subscriberId });
      toast.success(t('campaigns.subscriber_stopped'));
      onClose();
      onSuccess?.();
    } catch {
      // Error toast handled by the mutation onError
    }
  };

  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent className="gap-6 sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{t('campaigns.stop_subscriber_title')}</DialogTitle>
          <DialogDescription>{t('campaigns.stop_subscriber_description')}</DialogDescription>
        </DialogHeader>

        <div className="flex justify-end gap-2">
          <Button variant="ghost-neutral" onClick={onClose}>
            {t('common.back_to_safety')}
          </Button>
          <Button variant="destructive" onClick={handleStop} isLoading={isStopping}>
            {t('campaigns.stop')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
